import { CATEGORIES } from '../IssueStatuses/constants'

export const STATUS_LIST_CLASS = 'tw:py-0.5!'

export const STATUS_GROUP_CLASS = 'tw:flex tw:flex-col tw:p-1! '
  + 'tw:not-first:border-t tw:border-solid tw:border-gray-200'

export const statusOptionClassName = ({ isFocused, isSelected }) => 'tw:flex tw:items-center '
  + 'tw:w-full tw:pl-6! tw:pr-2! tw:py-2! tw:rounded! tw:border-0 tw:text-left tw:text-sm '
  + 'tw:leading-5! tw:text-[#0a0a0a]! tw:cursor-pointer! '
  + `${isSelected ? 'tw:font-semibold!' : 'tw:font-normal!'} `
  + `${isFocused ? 'tw:bg-gray-100!' : 'tw:bg-transparent! tw:hover:bg-gray-100!'}`

export const groupByCategory = statuses => CATEGORIES
  .map(category => ({
    value: category.value,
    label: category.label,
    options: statuses.filter(status => status.category === category.value)
  }))
  .filter(group => group.options.length > 0)
